import { faMapMarkerExclamation } from '@fortawesome/pro-duotone-svg-icons';

export default [faMapMarkerExclamation];
